import React from 'react';
import PropTypes from 'prop-types';

import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { areYouSure } from 'lib/utils/toast';
import { iconGrey, green } from 'lib/css/colors';
import { GLOBAL_PRODUCT_MANUFACTURER } from 'lib/networking/endpoints';
import { SwalToast } from 'lib/utils/toast';
import usePut from 'lib/hooks/usePut';

const STATUS_COLORS = {
  true: green,
  false: iconGrey,
};

function KnownSkuIcon({ knownSku, productId, refetch }) {
  const { putData: updateKnownSku } = usePut(GLOBAL_PRODUCT_MANUFACTURER, () => {
    refetch();
    SwalToast('success', 'Successfully Updated');
  });

  return (
    <OverlayTrigger overlay={<Tooltip>{'Whether a known sku or not yet'}</Tooltip>}>
      <FontAwesomeIcon
        icon={faCheck}
        color={STATUS_COLORS[knownSku] || iconGrey}
        size="lg"
        onClick={() => {
          const alertText = knownSku
            ? 'Are you sure you want to mark as unknown sku?'
            : 'Are you sure you want to mark as known sku?';

          areYouSure(
            () =>
              updateKnownSku({
                fsa_id: productId,
                known_sku: !knownSku,
              }),
            alertText,
          );
        }}
      />
    </OverlayTrigger>
  );
}

KnownSkuIcon.propTypes = {
  knownSku: PropTypes.bool.isRequired,
  productId: PropTypes.string.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default KnownSkuIcon;
